import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';

const BlogPost = () => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    apiService.getBlogPost(id)
      .then(response => {
        setPost(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching blog post:', error);
        setLoading(false);
      });
  }, [id]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <Container className="mt-5">
        <div className="text-center">
          <h2>Loading...</h2>
        </div>
      </Container>
    );
  }

  if (!post) {
    return (
      <Container className="mt-5">
        <div className="text-center">
          <h2>Post not found</h2>
          <Button variant="primary" onClick={() => navigate('/blog')}>
            Back to Blog
          </Button>
        </div>
      </Container>
    );
  }

  return (
    <Container className="mt-5">
      <Row>
        <Col lg={8} className="mx-auto">
          <Button 
            variant="outline-secondary" 
            className="mb-3"
            onClick={() => navigate('/blog')}
          >
            ← Back to Blog
          </Button>
          
          <article>
            <header className="mb-4">
              <h1>{post.title}</h1>
              <div className="text-muted">
                <small>
                  Published on {formatDate(post.createdAt)}
                  {post.author && ` by ${post.author.firstName} ${post.author.lastName}`}
                </small>
              </div>
            </header>
            
            <div className="blog-content">
              {post.content.split('\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </article>
        </Col>
      </Row>
    </Container>
  );
};

export default BlogPost;